import { useMutation, useQueryClient } from '@tanstack/react-query'
import { API_URL } from '@apis/axios'
import { postData } from '@pages/Event/simulate/v2/axios/axios'
import { AxiosError } from 'axios'

type RequestBodyType = {
  userId: string
  // SAMSUNG_INTEREST
  eventCode: string
}
const stagingAPI = 'https://staging-api.metalogos.site'

// 이벤트 참여 신청
const usePostEventParticipated = (
  mode: 'production' | 'staging' = 'production'
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: RequestBodyType) => {
      const res = await postData<undefined, RequestBodyType>(
        API_URL.EVENT_PARTICIPANT,
        body,
        {
          baseURL:
            mode === 'staging'
              ? stagingAPI
              : process.env.REACT_APP_REST_API_URI,
        }
      )
      return res.data.data
    },
    onSuccess: async (data, variables) => {
      const { userId } = variables

      await queryClient.invalidateQueries({
        queryKey: ['samsung-interest-event', userId],
      })
    },
    onError: (err) => {
      if (err instanceof AxiosError) {
        const { response } = err
        if (response?.status === 409) {
          alert('이미 참여한 이력이 있습니다.')
        }
      }
    },
  })
}
export default usePostEventParticipated
